import type { EditMenuCommands } from '../types/menu-items'
import type { MenubarInputs } from '../types/menubar-inputs'

/** Edit-menu rows shared by the desktop dropdown and the mobile sheet. */
export function buildEditMenuCommands({
  onUndo,
  onRedo,
  onCut,
  onCopy,
  onDuplicate,
  onPaste,
  onPasteInPlace,
  onDelete,
  cutDisabled = false,
  copyDisabled = false,
  duplicateDisabled = false,
  pasteDisabled = false,
  pasteInPlaceDisabled = false,
  deleteDisabled = false,
  onSelectAll,
  onSelectNone,
  selectNoneDisabled,
  onCheckSpelling,
}: MenubarInputs): EditMenuCommands {
  return {
    history: [
      { label: 'Undo', shortcutKey: 'undo', action: onUndo, disabled: !onUndo },
      { label: 'Redo', shortcutKey: 'redo', action: onRedo, disabled: !onRedo },
    ],
    clipboard: [
      { label: 'Cut', shortcutKey: 'cut', action: onCut, disabled: !onCut || cutDisabled },
      { label: 'Copy', shortcutKey: 'copy', action: onCopy, disabled: !onCopy || copyDisabled },
      {
        label: 'Duplicate',
        shortcutKey: 'duplicate',
        action: onDuplicate,
        disabled: !onDuplicate || duplicateDisabled,
      },
      {
        label: 'Paste',
        shortcutKey: 'paste',
        action: onPaste,
        disabled: !onPaste || pasteDisabled,
      },
      {
        label: 'Paste in Place',
        shortcutKey: 'pasteInPlace',
        action: onPasteInPlace,
        disabled: !onPasteInPlace || pasteInPlaceDisabled,
      },
      {
        label: 'Delete',
        shortcutKey: 'delete',
        action: onDelete,
        disabled: !onDelete || deleteDisabled,
      },
    ],
    selectAll: {
      label: 'Select All',
      shortcutKey: 'selectAll',
      action: onSelectAll,
      disabled: false,
    },
    selectNone: {
      label: 'Select None',
      shortcutKey: 'selectNone',
      action: onSelectNone,
      disabled: Boolean(selectNoneDisabled),
    },
    checkSpelling: { label: 'Check Spelling', action: onCheckSpelling, disabled: false },
  }
}
